export default __webpack_public_path__ + "static/unlock-bfe81fb4c33ecf2c13d2a35049d46ebd.png";